"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var PortionDTO_1 = require("../model/PortionDTO");

var PortionDTOConverter_1 = require("./PortionDTOConverter");

var PortionDTOConverterImpl =
/*#__PURE__*/
function (_PortionDTOConverter_) {
  _inherits(PortionDTOConverterImpl, _PortionDTOConverter_);

  function PortionDTOConverterImpl() {
    _classCallCheck(this, PortionDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PortionDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PortionDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var converter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.dataType
      });
      return new PortionDTO_1.PortionDTO(source.limit, source.offset, source.exceeded, conversions.asObjectList(source, 'result', function (o) {
        return converter.toObject(o, conversions);
      }), source.dataType);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var converter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.dataType
      });
      var result = {};
      Object.assign(result, {
        limit: source.limit,
        offset: source.offset,
        exceeded: source.exceeded,
        result: source.result.map(function (o) {
          return converter.toDocument(o, conversions);
        }),
        dataType: source.dataType
      });
      return result;
    }
  }]);

  return PortionDTOConverterImpl;
}(PortionDTOConverter_1.PortionDTOConverter);

exports.PortionDTOConverterImpl = PortionDTOConverterImpl;